import { useEffect, useState } from "react";
import api from "@/lib/api";

// Stage titles (labels only; stage logic lives on the server). Owners come live from Hiring Settings roles.
export const STAGE_TITLES = {
  1: "Quick review",
  2: "CSR phone interview",
  3: "Electrician interview",
  4: "Owner/COO interview",
  5: "Offer or decision",
};
export const STAGE_ROLE_KEY = {
  1: "stage_1_approver", 2: "stage_2_outreach_owner", 3: "stage_3_interviewer",
  4: "stage_4_interviewers", 5: "stage_4_meeting_offer_executor",
};

export const stageLabel = (n) => (STAGE_TITLES[n] ? `Stage ${n} · ${STAGE_TITLES[n]}` : `Stage ${n}`);

// roles: GET /hiring/roles → roles[]; returns { 1: ["Missie Bechard"], 4: ["Brett", "Nathanael"], ... }
export function ownersByStage(roles) {
  const byKey = Object.fromEntries((roles || []).map((r) => [r.role_key, r]));
  return Object.fromEntries(Object.entries(STAGE_ROLE_KEY).map(([n, k]) => {
    const r = byKey[k] || {};
    return [n, (r.primary_user_names || r.primary_user_emails || []).filter(Boolean)];
  }));
}

export const ownersText = (names) => (names?.length ? names.join(" & ") : "Unassigned");

export function useStageOwners() {
  const [owners, setOwners] = useState({});
  useEffect(() => {
    let live = true;
    api.get("/hiring/roles").then(({ data }) => live && setOwners(ownersByStage(data?.roles))).catch(() => {});
    return () => { live = false; };
  }, []);
  return owners;
}

export const StageTitle = ({ stage, owners, testId, className = "" }) => (
  <span className={`inline-flex flex-col leading-tight ${className}`} data-testid={testId}>
    <span className="font-semibold">{stageLabel(stage)}</span>
    {owners && (
      <span className={`text-[11px] font-normal normal-case tracking-normal ${owners[stage]?.length ? "opacity-75" : "text-[#b45309]"}`}
            data-testid={testId ? `${testId}-owner` : undefined}>
        {ownersText(owners[stage])}
      </span>
    )}
  </span>
);
